
import { NgModule } from '@angular/core';
import {ToastyModule} from 'ng2-toasty';
import { ServersService } from '../servicios/servers.service';
import { HttpCacheService } from '../servicios/httpcache.service';
import { AlertService } from '../servicios/alert.service';
import { UsuarioService } from '../servicios/usuario.service';
import { EmpresaService } from '../servicios/empresa.service';
import { TipoServicioService } from '../servicios/tiposervicio.service';
import { PersonaService } from '../servicios/persona.service';
import { VehiculoService } from '../servicios/vehiculo.service';
import { ChartsModule } from 'ng2-charts';
import { AngularFireAuth } from 'angularfire2/auth';
import { AngularFireDatabase } from 'angularfire2/database';

@NgModule({
    imports: [ToastyModule.forRoot()],
    providers: [
        ServersService,
        HttpCacheService,
        UsuarioService,
        AlertService,
        EmpresaService,
        TipoServicioService,
        PersonaService,
        VehiculoService, AngularFireAuth, AngularFireDatabase
    ]
})
export class ServicesModule { }



// WEBPACK FOOTER //
// ./src/app/modules/services.module.ts